<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card v-if="!is_on_create" title="RM ORDERS" >
          <div v-can="'view-raw-material-orders'" slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="rm-order-list" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" >DATE/TIME</vs-th>
                <vs-th width="10%" >ORDER CODE</vs-th>
                <vs-th width="15%" >SUPPLIER</vs-th>
                <vs-th width="15%">ORDERED BY</vs-th>
                <vs-th width="30%" >RM ITEMS</vs-th>
                <vs-th width="20%" >STATUS</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr v-if="tr.raw_material_items.filter(n => n.is_added_to_stock === false).length > 0" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td  v-if="tr.raw_material_items.filter(n => n.is_added_to_stock === false).length === 0" >

                  </vs-td>

                  <vs-td class="text-sm	" :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td  class="font-semibold text-primary" :data="data[indextr].purchase_order_code">
                    {{ data[indextr].purchase_order_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier">
                    {{ data[indextr].supplier}}
                  </vs-td>

                  <vs-td :data="data[indextr].staff">
                    {{ data[indextr].staff}}
                  </vs-td>


                  <vs-td :data="data[indextr].raw_material_items">
                    <span v-if="data[indextr].raw_material_items.length > 0" v-for="(item, index_item) in data[indextr].raw_material_items" :key="item.id">
                      <a v-on:click.prevent="onClickFinishedProduct(item.id)">{{item.category.prefix}}-{{ item.company_product_code }}</a>
                      <span v-if="data[indextr].raw_material_items.length !== index_item+1"> , </span>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0" class="text-center" transparent :color="data[indextr].is_item_status_handled_individually ? 'dark' : ProductOrderStatusColorFactory(tr.status.name)">
                      {{ data[indextr].is_item_status_handled_individually ? 'PO Ungrouped' : data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">
                      <vs-table
                        :data="data[indextr].raw_material_items.filter(n => n.is_added_to_stock === false)"
                        :hoverFlat="true"
                        class="m-16">
                        <template slot="thead">
                          <vs-th width="15%" class="text-sm">ITS PRODUCT CODE</vs-th>
                          <vs-th width="15%" class="text-sm">ITS PRODUCT NAME</vs-th>
                          <vs-th width="15%" class="text-sm">QUANTITY (Kg)</vs-th>
                          <vs-th width="15%" class="text-sm">PRICE (GBP)</vs-th>
                          <vs-th width="15%" class="text-sm">ITEM STATUS</vs-th>
                          <vs-th width="15%" class="text-sm">ADDED TO STOCK</vs-th>
                          <vs-th width="15%" class="text-sm">ACTION</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr @click.native="onClickAddStock(tr_item, tr)" class="text-sm" :key="index_item" v-for="(tr_item, index_item) in data">

                            <vs-td :data="tr_item.company_product_code">
                              {{ tr_item.category.prefix }} - {{ tr_item.company_product_code }}
                            </vs-td>

                            <vs-td :data="tr_item.company_product_name">
                              {{tr_item.company_product_name}}
                            </vs-td>

                            <vs-td :data="tr_item.quantity">
                              {{tr_item.quantity}}
                            </vs-td>

                            <vs-td :data="tr_item.quantity">
                              {{ Number(tr_item.price).toFixed(2) }}
                            </vs-td>

                            <vs-td :data="tr_item.item_status">
                              {{tr_item.item_status}}
                            </vs-td>

                            <vs-td :data="tr_item.is_added_to_stock">
                              {{tr_item.is_added_to_stock ? 'Added' : 'Not Added'}}
                            </vs-td>

                            <vs-td>
                              <div class="vx-row">
                                <vx-tooltip v-if="!tr_item.is_added_to_stock && tr_item.item_status === 'Received - QC Passed'" text="Add to Stock" position="left">
                                  <vs-button class="ml-3"
                                             @click.stop="onClickAddStock(tr_item)"
                                             size="small" color="primary" type="border" icon-pack="feather" icon="icon-share"></vs-button>
                                </vx-tooltip>
                              </div>
                            </vs-td>

                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </template>

                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"
              class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-rm-stock-pop-up ref="createRmStockPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  const InventoryRepository = RepositoryFactory.get('inventory')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {raw_material_order_statuses} from '@/constants/statuses'
  import {defaultPagination, perPageList} from "@/constants/config";
  import CreateRmStockPopUp from "@/components/popups/manufacturing/raw-material-stock/CreateRmStockPopUp";

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        is_on_create: false,
        viewDetailsOrder: {},
        perPage: defaultPagination,
        descriptionItems: perPageList,
        raw_material_order_statuses: raw_material_order_statuses
      }
    },
    components: {
      'v-select': vSelect,
      CreateRmStockPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    methods: {
      async refreshData () {
        this.$router.push({path: `/pages/manufacturing/raw-material-stock`})
      },
      async getProductOrderList() {
        await this.$vs.loading({
          container: '#rm-order-list',
          scale: 0.45
        })
        const {data} = await InventoryRepository.getRmOrderList(this.page, this.filterQuery, this.perPage, '')
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#rm-order-list > .con-vs-loading')
      },
      onClickDetailsView(id) {
        this.$router.push({path: `/pages/raw-materials/orders/${id}`})
      },

      filterQueryUpdate (){
        this.getProductOrderList()
      },

      handleChangePage(page) {
        this.page=page;
        this.getProductOrderList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.getProductOrderList()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      ProductOrderStatusColorFactory(status_name) {
        let selected_status = this.raw_material_order_statuses.find((n) => n.name === status_name)
        return selected_status ?  selected_status.color : 'warning'
      },
      onClickFinishedProduct(id) {
        // this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      checkRmItemsAreEqual(items) {
        return items.map((n) => n.item_status).every( (val, i, arr) => val === arr[0] )
      },
      onClickAddStock(rm_item) {
        this.$refs.createRmStockPopUp.openPopup(rm_item)
      }

    },
    watch : {
      page(){
        this.getProductOrderList()
      },
      perPage() {
        this.getProductOrderList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
